import { motion } from "framer-motion";
import { useLenis } from "lenis/react";

export default function Header() {
  const lenis = useLenis();

  const goToAccess = () => {
    if (lenis) {
      lenis.scrollTo("#access", { offset: -72, duration: 1.6 });
    } else {
      document.getElementById("access")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <motion.header
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 sm:h-20 sm:px-12 lg:px-16">
        <a href="#top" data-testid="header-logo-link" aria-label="AxenLabs home"
          onClick={(e) => { e.preventDefault(); lenis ? lenis.scrollTo(0, { duration: 1.4 }) : window.scrollTo({ top: 0, behavior: "smooth" }); }}>
          <img src="/logo-full.png" alt="AxenLabs" className="h-6 w-auto sm:h-7" data-testid="header-logo" />
        </a>
        <button
          type="button"
          onClick={goToAccess}
          data-testid="header-get-early-access-button"
          className="rounded-full border border-white/30 px-5 py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-white hover:text-black sm:px-7 sm:py-2.5 sm:text-xs"
        >
          Get Early Access
        </button>
      </div>
    </motion.header>
  );
}
